import {Component, Input, OnInit} from '@angular/core';
import {CustomerProfile} from '../../modules/customers/shared/api/entity';
import {PROFILE_TYPE} from '../../../../common/constants';

@Component({
    selector: 'tfl-bo-card-box-content-profile-resolver',
    template: `
        <div [ngSwitch]="true">
            <div *ngSwitchCase="customer.type == TYPE.PRIVATE" class="row">
                <tfb-bo-card-box-private-content [customer]="customer"></tfb-bo-card-box-private-content>
            </div>
            <div *ngSwitchCase="customer.type == TYPE.CORPORATE" class="row">
                <tfb-bo-card-box-corporate-content [customer]="customer"></tfb-bo-card-box-corporate-content>
            </div>
        </div>`
})
export class CardBoxProfileContentResolver implements OnInit {

    readonly TYPE = PROFILE_TYPE;

    @Input('customer') customer: CustomerProfile;

    ngOnInit(): void {
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/card-box.profile.content.resolver.ts